/*
 * WebGas - Omaggio automatico al raggiungimento della soglia
 *
 * Aggiunge la variante omaggio quando il carrello supera la soglia e la toglie
 * quando scende sotto. La configurazione arriva da snippets/webgas-cart-gift.liquid
 * in window.wgCartGift.
 *
 * Se il cliente rimuove l'omaggio a mano non viene riaggiunto: il gesto viene
 * registrato per la sessione e azzerato quando il carrello riscende sotto soglia.
 */
(function () {
  var config = window.wgCartGift;
  if (!config || !config.enabled || !config.variantId || !config.threshold) return;

  /* Si accetta sia l'id numerico sia il formato gid://shopify/ProductVariant/123 */
  config.variantId = parseInt(String(config.variantId).replace(/\D/g, ''), 10);
  if (!config.variantId) return;

  var GIFT_PROPERTY = '_wg_omaggio';
  var STORAGE_ADDED = 'wgCartGiftAdded';
  var STORAGE_DISMISSED = 'wgCartGiftDismissed';

  /*
   * Il blocco per omaggio a pagamento vive solo quanto la pagina: la causa e' lato
   * server (sconto automatico assente o non applicato) e puo' rientrare da un momento
   * all'altro. In sessionStorage sopravviverebbe ai reload e la scheda non riproverebbe
   * piu' nemmeno dopo aver attivato lo sconto.
   */
  var blocked = false;

  /* Diagnostica: si accende con ?wg_debug in URL o con window.wgCartGift.debug = true */
  var DEBUG = false;
  try {
    DEBUG = config.debug === true || window.location.search.indexOf('wg_debug') !== -1;
  } catch (e) {}

  function log() {
    if (!DEBUG) return;
    console.log.apply(console, ['[wg-cart-gift]'].concat([].slice.call(arguments)));
  }

  var busy = false;
  var syncTimer = null;
  var originalFetch = window.fetch.bind(window);

  function readFlag(key) {
    try {
      return window.sessionStorage.getItem(key) === String(config.variantId);
    } catch (e) {
      return false;
    }
  }

  function writeFlag(key, on) {
    try {
      if (on) {
        window.sessionStorage.setItem(key, String(config.variantId));
      } else {
        window.sessionStorage.removeItem(key);
      }
    } catch (e) {
      /* navigazione in incognito o storage disabilitato: si prosegue senza memoria */
    }
  }

  function cartRoute(suffix) {
    var base = (window.routes && window.routes.cart_url) || '/cart';
    return base + suffix;
  }

  /* Sezioni da ridisegnare dopo una modifica, allineate ad assets/cart.js */
  function sectionsToRender() {
    var sections = [
      { id: 'mini-cart', section: 'mini-cart', selector: '.shopify-section' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
      { id: 'mobile-cart-icon-bubble', section: 'mobile-cart-icon-bubble', selector: '.shopify-section' },
      { id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' }
    ];

    var items = document.getElementById('main-cart-items');
    if (items && items.dataset.id) {
      sections.push({ id: 'main-cart-items', section: items.dataset.id, selector: '.js-contents' });
    }

    var footer = document.getElementById('main-cart-footer');
    if (footer && footer.dataset.id) {
      sections.push({ id: 'main-cart-footer', section: footer.dataset.id, selector: '.js-contents' });
      if (footer.querySelector('.free-shipping')) {
        sections.push({ id: 'main-cart-footer', section: footer.dataset.id, selector: '.free-shipping' });
      }
    }

    return sections;
  }

  function sectionInnerHTML(html, selector) {
    var parsed = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return parsed ? parsed.innerHTML : null;
  }

  function renderSections(parsedState) {
    if (!parsedState || !parsedState.sections) return;

    sectionsToRender().forEach(function (section) {
      var element = document.getElementById(section.id);
      if (!element) return;

      var markup = parsedState.sections[section.section];
      if (!markup) return;

      var target = element.querySelector(section.selector) || element;
      var html = sectionInnerHTML(markup, section.selector);
      if (html !== null) target.innerHTML = html;
    });
  }

  function postCart(path, payload) {
    payload.sections = sectionsToRender().map(function (section) {
      return section.section;
    });
    payload.sections_url = window.location.pathname;

    return originalFetch(path, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(function (response) {
      return response
        .json()
        .catch(function () {
          return {};
        })
        .then(function (body) {
          if (!response.ok) {
            /* Senza questo controllo un 422 passerebbe per un'aggiunta riuscita. */
            var reason = body.description || body.message || response.statusText;
            throw new Error('richiesta ' + path + ' fallita: ' + response.status + ' ' + reason);
          }
          return body;
        });
    });
  }

  function addGift() {
    var properties = {};
    properties[GIFT_PROPERTY] = 'true';

    return postCart(cartRoute('/add.js'), {
      items: [{ id: config.variantId, quantity: 1, properties: properties }]
    });
  }

  function setGiftQuantity(key, quantity) {
    return postCart(cartRoute('/change.js'), { id: key, quantity: quantity });
  }

  function sync() {
    if (busy) return Promise.resolve();
    busy = true;

    return originalFetch(cartRoute('.js'), { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var gift = null;

        var subtotal = cart.items.reduce(function (sum, item) {
          if (item.variant_id === config.variantId) {
            gift = item;
            return sum;
          }
          return sum + item.final_line_price;
        }, 0);

        var reached = subtotal >= config.threshold;

        log('subtotale', subtotal, 'soglia', config.threshold, 'raggiunta', reached, {
          omaggioInCarrello: gift ? gift.quantity : 0,
          omaggioCosta: gift ? gift.final_line_price : null,
          aggiunto: readFlag(STORAGE_ADDED),
          rifiutato: readFlag(STORAGE_DISMISSED),
          bloccato: blocked
        });

        if (!reached) {
          /* Sotto soglia il ciclo si riapre: un eventuale rifiuto precedente decade */
          writeFlag(STORAGE_DISMISSED, false);
          writeFlag(STORAGE_ADDED, false);
          blocked = false;
          if (gift) return setGiftQuantity(gift.key, 0).then(renderSections);
          return null;
        }

        if (gift) {
          /*
           * Il tema mette la variante nel carrello, non ne azzera il prezzo: quello lo
           * fa lo sconto automatico configurato nell'admin. Se manca, l'omaggio sarebbe
           * a pagamento: si toglie subito invece di addebitarlo a sorpresa.
           */
          if (gift.final_line_price > 0) {
            log('rimozione: la riga costa', gift.final_line_price, 'invece di 0');
            blocked = true;
            writeFlag(STORAGE_ADDED, false);
            console.warn('[wg-cart-gift] omaggio a pagamento, sconto automatico assente o non applicato: riga rimossa');
            return setGiftQuantity(gift.key, 0).then(renderSections);
          }

          writeFlag(STORAGE_ADDED, true);
          /* L'omaggio resta uno solo, anche se il cliente ne alza la quantita' */
          if (gift.quantity > 1) return setGiftQuantity(gift.key, 1).then(renderSections);
          return null;
        }

        if (blocked) return null;

        /* Sopra soglia e omaggio assente dopo essere stato aggiunto: l'ha tolto il cliente */
        if (readFlag(STORAGE_ADDED)) {
          writeFlag(STORAGE_DISMISSED, true);
          writeFlag(STORAGE_ADDED, false);
          return null;
        }

        if (readFlag(STORAGE_DISMISSED)) return null;

        log('aggiunta omaggio, variante', config.variantId);
        return addGift().then(function (parsedState) {
          writeFlag(STORAGE_ADDED, true);
          renderSections(parsedState);
          /* Secondo giro per verificare che lo sconto automatico abbia azzerato la riga */
          scheduleSync();
        });
      })
      .catch(function (error) {
        console.error('[wg-cart-gift]', error);
      })
      .finally(function () {
        busy = false;
      });
  }

  function scheduleSync() {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(sync, 120);
  }

  /*
   * Il tema aggiorna il carrello da piu' punti (cart.js, color-swatches.js, add-to-cart)
   * e non tutti emettono un evento. Si osservano quindi le chiamate agli endpoint del
   * carrello, lasciando la risposta originale intatta.
   */
  window.fetch = function (input, init) {
    var promise = originalFetch(input, init);
    var url = typeof input === 'string' ? input : (input && input.url) || '';

    if (!busy && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      promise.then(function () {
        scheduleSync();
      }).catch(function () {
        /* l'errore lo gestisce il chiamante originale */
      });
    }

    return promise;
  };

  document.addEventListener('cart:updated', scheduleSync);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSync);
  } else {
    scheduleSync();
  }
})();
